import {
  IconButton,
  Stack,
  Tab,
  Tabs,
  Box,
  TextField,
  Paper,
  Grid,
  Tooltip,
  MenuItem,
  ListItemText,
  Select,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemIcon,
  Menu,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { Done, Close, Message, Edit, PauseCircle, KeyboardArrowDown, MoreVert, ManageSearch, HourglassTop, Payments, Undo, } from "@mui/icons-material";
import { TabPanel, TabContext, LoadingButton } from "@mui/lab";
import moment from "moment";
import * as XLSX from "xlsx";
import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useTransition,
  useDeferredValue,
  useRef,
} from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import AsyncDropdown from "../../utils/asyncDropdown/AsyncDropdown";
import ConfirmAlert from "../../utils/ConfirmAlert";
import TopHeading from "../../utils/TopHeading/TopHeading";
import AnimatedPage from "../animatedPage/AnimatedPage";
import Hoc from "../HOC/Hoc";
import "../RedemptionRequest/Style.css";
import {
  approveRequest,
  getActivepanels,
  getRedemptionData,
  getPanelistCategory,
  getPanelCountryLanguage,
  getRedeemptionRequestsByFilter,
} from "./Redemption.api";
import ConfRedemption from "./ConfRedemption";
import CustomDataTable from "../../views/CustomTable/CustomDataTable";
import { SnackBarAlert } from "../../utils/SnackBar";
import CustomTooltip from "../../../src/utils/CustomTooltip";

const Redemption = (props) => {
  const {
    loading,
    handleOpenModal,
    setSuccess,
    setError,
    openEditModal,
    handleOpenEditModal,
    handleCloseEditModal,
    setAlert,
    alert,
  } = props;

  const tenantId = useSelector((state) => state.auth.userData?.tenantId);
  const adminId = useSelector((state) => state.auth.userData?.adminId);

  const [activePanels, setActivePanels] = useState([]);
  const [selectedPanel, setSelectedPanel] = useState({});
  const [pageloading, setPageloading] = useState(false);
  const [dataUpdated, setDataUpdated] = useState(false);
  const [editId, seteditId] = useState({});
  const [selectedItem, setselectedItem] = useState({});
  const [value, setValue] = useState("pending");
  const [pending, setPending] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [isApprovedBtn, setIsApprovedBtn] = useState(true);
  const [isPauseBtn, setIsPauseBtn] = useState(true);
  const [filterData, setFilterData] = useState({
    startDate: moment().subtract(3, "months").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    maxDate: moment().format("YYYY-MM-DD"),
  });
  const [actionStatus, setActionStatus] = useState("reject");
  const [confirmMessage, setConfirmMessage] = useState("Disapprove");
  const [redemptionResponseData, setRedemptionResponseData] = useState([]);
  const [categoryItem, setCategoryItem] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [loadAllCountries, setLoadAllCountries] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [actionsDisabled, setActionsDisabled] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [menuRow, setMenuRow] = useState(null);
  const [approveRow, setApproveRow] = useState(null);
  const [statusConfirm, setStatusConfirm] = useState(null);

  const MAIN_TABS = [
  { label: "Submitted", value: "pending" },
  { label: "Under Review", value: "underReview" },
  { label: "Awaiting Approval", value: "awaitingApproval" },
  { label: "Payment Verification", value: "verification" },
  ];

  const MORE_TABS = [
    { label: "Approved", value: "approved" },
    { label: "Disapproved", value: "disapproved" },
    { label: "Failed", value: "failed" },
    { label: "Hold", value: "hold" },
  ];

  const ACTION_META = {
    underReview:         { label: "Under Review",             icon: <ManageSearch fontSize="small" sx={{ color: "#0288d1" }} /> },
    awaitingApproval:    { label: "Awaiting Client Approval", icon: <HourglassTop fontSize="small" sx={{ color: "#ed6c02" }} /> },
    verification: { label: "Payment Verification",     icon: <Payments fontSize="small" sx={{ color: "#6a1b9a" }} /> },
    approve:             { label: "Approve",                  icon: <Done fontSize="small" sx={{ color: "#2e7d32" }} /> },
    disapprove:          { label: "Disapprove",               icon: <Close fontSize="small" sx={{ color: "#d32f2f" }} /> },
    hold:                { label: "Hold",                     icon: <PauseCircle fontSize="small" sx={{ color: "#f9a825" }} /> },
    editReason:          { label: "Edit Reason",              icon: <Edit fontSize="small" sx={{ color: "#1976d2" }} /> },
    undoStatus:           { label: "ERROR - Undo List Change", icon: <Undo fontSize="small" sx={{ color: "#c62828" }} /> },
  };

  // Tab value -> eligible actions (PDF: "Admin Actions by Redemption List")
  // const ACTIONS_BY_TAB = {
  //   pending: ["underReview", "approve", "disapprove", "hold"],
  //   underReview: ["awaitingApproval", "approve", "disapprove", "verification", "hold"],
  //   awaitingApproval: ["verification", "approve", "disapprove", "hold"],
  //   verification: ["approve"],
  //   hold: ["approve", "disapprove", "editReason"],
  // };  
  const ACTION_TABS = ["pending", "underReview", "awaitingApproval", "verification", "hold"];

  const ALL_ACTIONS = [
    "underReview",
    "awaitingApproval",
    "verification",
    "approve",
    "disapprove",
    "hold",
  ];

  const [moreAnchor, setMoreAnchor] = useState(null);
  const activeMoreTab = MORE_TABS.find((t) => t.value === value);
  const [isTabTransitionPending, startTabTransition] = useTransition();
  const deferredSearchQuery = useDeferredValue(searchQuery);
  const abortControllerRef = useRef(null);

  const isAllCategorySelected =
    categoryList.length > 0 && selectedCategory.length === categoryList.length;

    const getActionsForTab = (tab) => {
      if (!ACTION_TABS.includes(tab)) return [];
      const list = ALL_ACTIONS.filter((a) => a !== tab);
      if (tab === "hold") list.push("editReason"); // hold tab me reason edit bhi chahiye
      return list;
    };
  // ─── Handlers ────────────────────────────────────────────────────────────────
    const handleMenuOpen = useCallback((e, row) => {
    setMenuAnchor(e.currentTarget);
    setMenuRow(row);
  }, []);

  const handleMenuClose = useCallback(() => {
    setMenuAnchor(null);
    setMenuRow(null);
  }, []);

  const handleChange = useCallback((event, newValue) => {
    if (newValue === "more") return;
    startTabTransition(() => {
      setPending(true);
      setValue(newValue);
    });
  }, []);

  const handleChangeCountry = useCallback(
    (event) => {
      const val = event.target.value;
      if (val[val.length - 1] === "all") {
        const selectAll = selectedCountry.length !== loadAllCountries.length;
        setSelectedCountry(selectAll ? loadAllCountries : []);
        setIsAllSelected(selectAll);
        return;
      }
      setSelectedCountry(val);
      setIsAllSelected(val.length === loadAllCountries.length);
    },
    [selectedCountry, loadAllCountries]
  );

  const handleCategoryChange = useCallback(
    (event) => {
      const val = event.target.value;
      if (val[val.length - 1] === "all") {
        setSelectedCategory(
          isAllCategorySelected ? [] : categoryList.map((item) => item.categoryType)
        );
        setCategoryItem([]);
        return;
      }
      const selectedIds = categoryList
        .filter((res) => val.includes(res.categoryType))
        .map((item) => item.id);
      setCategoryItem(selectedIds);
      setSelectedCategory(val);
    },
    [categoryList, isAllCategorySelected]
  );

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = useMemo(
    () => ({
      PaperProps: {
        style: { maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP, width: 250 },
      },
    }),
    []
  );

  // ─── Data fetching ────────────────────────────────────────────────────────────

  const refreshRedeemptionWithFilter = useCallback(
    (panelId, utid) => {
      // Cancel any in-flight request for this panel+tab
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      abortControllerRef.current = new AbortController();

      const filterDataRequest = {
        startDate: filterData.startDate,
        endDate: filterData.endDate,
        status: value,
        ...(categoryItem.length > 0 && { categoryType: categoryItem }),
      };

      return getRedeemptionRequestsByFilter(panelId, filterDataRequest)
        .then((res) => {
          if (res?.status === 200) {
            const responseData = res.data.data || [];
            const activeCountries =
              selectedCountry.length > 0 ? selectedCountry : loadAllCountries;
            const filtered =
              activeCountries.length > 0
                ? responseData.filter((item) =>
                    activeCountries.includes(item.countryCode)
                  )
                : responseData;
            setRedemptionResponseData(filtered);
          }
        })
        .catch((err) => {
          if (err?.name !== "AbortError") {
            console.log("err", err.message);
          }
        })
        .finally(() => {
          if (utid != null) {
            disableEnableRedemption(utid, "enable");
          }
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [filterData.startDate, filterData.endDate, value, categoryItem, selectedCountry, loadAllCountries]
  );

  // Fetch on tab change or panel change
  useEffect(() => {
    if (!selectedPanel?.panelId) return;
    setPageloading(true);
    setPending(true);
    refreshRedeemptionWithFilter(selectedPanel.panelId, value).finally(() => {
      setPending(false);
      setPageloading(false);
    });
  }, [value, selectedPanel?.panelId, loadAllCountries.length]);
  // NOTE: intentionally not including refreshRedeemptionWithFilter to avoid
  // re-fetching when filter inputs change mid-session (user hits Search for that)

  // Fetch active panels once
  useEffect(() => {
    getActivepanels(tenantId)
      .then((res) => {
        if (res?.status === 200) {
          const { data } = res.data;
          setActivePanels(data);
          setSelectedPanel(data[0]);
        }
      })
      .catch(console.error);
  }, [tenantId]);

  // Fetch category + country lists once, in parallel
  useEffect(() => {
    let mounted = true;

    Promise.allSettled([getPanelistCategory(), getPanelCountryLanguage(30)]).then(
      ([categoryResult, countryResult]) => {
        if (!mounted) return;

        if (
          categoryResult.status === "fulfilled" &&
          categoryResult.value?.status === 200 &&
          categoryResult.value.data.success
        ) {
          setCategoryList(categoryResult.value.data.data);
        } else {
          setCategoryList([]);
        }

        if (
          countryResult.status === "fulfilled" &&
          countryResult.value?.status === 200 &&
          countryResult.value.data.success
        ) {
          const uniqueItems = countryResult.value.data.data;
          setCountryList(uniqueItems);
          setLoadAllCountries(uniqueItems.map((el) => el.countryCode));
        } else {
          setCountryList([]);
        }
      }
    );

    return () => {
      mounted = false;
    };
  }, []);

  // ─── Derived data ─────────────────────────────────────────────────────────────

  const redemptionArray = useMemo(() => {
    const tabStatus = value.toLowerCase();
    return redemptionResponseData.filter(
      (req) => (req.status ?? "").toLowerCase() === tabStatus
    );
  }, [redemptionResponseData, value]);

  const safeToString = useCallback(
    (val) => (val ? val.toString().toLowerCase() : ""),
    []
  );

  // Uses deferredSearchQuery so typing never blocks the main thread
  const filteredData = useMemo(() => {
    const q = deferredSearchQuery.trim().toLowerCase();
    if (!q) return redemptionArray;
    const searchValues = q
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean);
    return redemptionArray.filter((item) =>
      searchValues.some(
        (val) =>
          safeToString(item.panelistId).includes(val) ||
          safeToString(item.email).includes(val) ||
          safeToString(item.rewardName).includes(val)
      )
    );
  }, [redemptionArray, deferredSearchQuery, safeToString]);

  // ─── Actions ──────────────────────────────────────────────────────────────────

  const disableEnableRedemption = useCallback((utid, type) => {
    setActionsDisabled(type === "disable");
  }, []);

  const approveRequestHandler = useCallback(
    (id, utid, panelId) => {
      setPageloading(true);
      setIsApprovedBtn(true);
      disableEnableRedemption(utid, "disable");

      const data = {
        utid,
        status: "approved",
        redemptionStatus: "complete",
        approvedBy: adminId,
        updatedBy: adminId,
      };

      approveRequest(id, data, selectedPanel?.panelGuid)
        .then((res) => {
          disableEnableRedemption(utid, "disable");
          if (res?.status === 200) {
            if (res?.data?.success) {
              const approvedStatus = res?.data?.data[0]?.status;
              const invalidIP = res?.data?.message === "Invalid IP";

              if (approvedStatus === "approved" || invalidIP) {
                setAlert(
                  approvedStatus === "approved"
                    ? "Redemption approved Successfully"
                    : res?.data?.message
                );
                setRedemptionResponseData((prev) =>
                  prev.filter((item) => item.id !== id)
                );
              }
            } else {
              setAlert(
                res?.data?.message ||
                  "Unable to process your request. Please contact the dev team."
              );
              return;
            }
          } else {
            setAlert("Something went wrong");
            return;
          }
          if (res?.status === undefined) {
            setRedemptionResponseData((prev) =>
              prev.filter((item) => item.id !== id)
            );
          }
        })
        .catch(() => {
          disableEnableRedemption(utid, "enable");
        })
        .finally(() => {
          setPageloading(false);
          disableEnableRedemption(utid, "enable");
        });
    },
    [adminId, selectedPanel?.panelGuid, disableEnableRedemption, setAlert]
  );

  const handleApprove = useCallback(
    (row, status, confirmStatus) => {
      seteditId(row.id);
      setselectedItem(row);
      setActionStatus(status);
      setConfirmMessage(confirmStatus);
      handleOpenEditModal();
    },
    [handleOpenEditModal]
  );

  const changeStatusHandler = useCallback(
  (row, newStatus, successMsg) => {
    setPageloading(true);
    disableEnableRedemption(row.utid, "disable");

    approveRequest(
      row.id,
      { utid: row.utid, status: newStatus, updatedBy: adminId },
      selectedPanel?.panelGuid
    )
      .then((res) => {
        if (res?.status === 200 && res?.data?.success) {
          setAlert(successMsg);
          // row is tab se hat jayegi (naye tab me chali gayi)
          setRedemptionResponseData((prev) => prev.filter((i) => i.id !== row.id));
        } else {
          setAlert(res?.data?.message || "Something went wrong");
        }
      })
      .catch(() => setAlert("Something went wrong"))
      .finally(() => {
        setPageloading(false);
        disableEnableRedemption(row.utid, "enable");
      });
    },
    [adminId, selectedPanel?.panelGuid, disableEnableRedemption, setAlert]
  );

  const handleMenuAction = useCallback(

  (action, rowArg) => {
     const row = rowArg || menuRow;
    handleMenuClose();
    if (!row) return;

    switch (action) {
      case "approve":
        setApproveRow(row); // confirm dialog, phir purana approveRequestHandler
        break;
      case "disapprove":
        handleApprove(row, "reject", "Disapprove");
        break;
      case "hold":
      case "editReason":
        handleApprove(row, "hold", "hold");
        break;
      case "underReview":
        setStatusConfirm({
          row,
          newStatus: "underReview",
          successMsg: "Moved to Under Review",
          title: "move this redemption to Under Review",
        });
        break;
      case "awaitingApproval":
        setStatusConfirm({
          row,
          newStatus: "awaitingApproval",
          successMsg: "Moved to Awaiting Client Approval",
          title: "move this redemption to Awaiting Client Approval",
        });
        break;
      case "verification":
        setStatusConfirm({
          row,
          newStatus: "verification",
          successMsg: "Moved to Payment Verification",
          title: "move this redemption to Payment Verification",
        });
        break;
      case "undoStatus":
        setStatusConfirm({
          row,
          newStatus: "undoStatus",
          successMsg: "List change undone",
          title: "verify and update this redemption status",
        });
        break;
      default:
        break;
    }
  },
  [menuRow, handleMenuClose, handleApprove, changeStatusHandler]
  );

  const handleMenuActionRef = useRef(handleMenuAction);
  useEffect(() => {
      handleMenuActionRef.current = handleMenuAction;
  }, [handleMenuAction]);

  const handleSearch = useCallback((e) => {
    setSearchQuery(e.target.value);
  }, []);

  const handleCloseAlert = useCallback(() => {
    setAlert(false);
  }, [setAlert]);

  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleSearchFilter = useCallback(() => {
    setPending(true);
    setPageloading(true);
    refreshRedeemptionWithFilter(selectedPanel?.panelId, null).finally(() => {
      setPending(false);
      setPageloading(false);
    });
  }, [refreshRedeemptionWithFilter, selectedPanel?.panelId]);

  const downloadRedemptionData = useCallback(() => {
    getRedemptionData(value.toLowerCase(), filterData.startDate, filterData.endDate)
      .then((res) => {
        const redemptionValue = res.data.data;
        if (redemptionValue.length === 0) {
          setAlert("No data available");
          return;
        }
        const worksheet = XLSX.utils.json_to_sheet(redemptionValue);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Redemption");
        XLSX.writeFile(workbook, `${value} Redemption.xlsx`);
      })
      .catch(() => {});
  }, [value, filterData.startDate, filterData.endDate, setAlert]);

  // ─── Memoized helpers ─────────────────────────────────────────────────────────

  const firstLetterCaps = useCallback(
    (string) => string.charAt(0).toUpperCase() + string.slice(1),
    []
  );

  const sortedCountryList = useMemo(
    () => [...countryList].sort((a, b) => a.countryName.localeCompare(b.countryName)),
    [countryList]
  );

  const sortedCategoryList = useMemo(
    () => [...categoryList].sort((a, b) => a.categoryType.localeCompare(b.categoryType)),
    [categoryList]
  );

  // ─── Columns (unchanged logic, stable reference) ──────────────────────────────

  const columns = useMemo(
    () => [
      {
        name: "ID",
        selector: (row) => row.id,
        sortable: true,
        minWidth: "70px",
        maxWidth: "100px",
        omit: value === "pending",
      },
      {
        name: <div>Panelist Id</div>,
        selector: (row) => row.panelistId,
        sortable: true,
        cell: (row) => (
          <Stack direction={"row"}>
            <Link
              className={
                value === "pending" &&
                row.categoryType?.toLowerCase() === "premium" &&
                parseFloat(row.profit) < 0
                  ? "text-light"
                  : ""
              }
              to={`/admin/panelist-detail/${row.panelistId}`}
              target="_blank"
            >
              {row.panelistId}
            </Link>
          </Stack>
        ),
      },
      {
        name: <div>Email</div>,
        selector: (row) => row.email,
        cell: (row) => (
          <CustomTooltip
            title={row.email || "Email Not Found"}
            childrenText={row.email || "--"}
            copiedText
          />
        ),
        sortable: true,
        minWidth: "170px",
        maxWidth: "170px",
      },
      {
        name: (
          <Tooltip title="Redeem Count" placement="top">
            <div>Count</div>
          </Tooltip>
        ),
        selector: (row) => row.redeemCount,
        cell: (row) => (
          <Tooltip
            title={`Total Redeemed USD Amount: ${row.totalRedeemedUsd ?? 0}`}
            placement="top"
          >
            <div className="text-underline">{row.redeemCount}</div>
          </Tooltip>
        ),
        sortable: true,
        minWidth: "80px",
        maxWidth: "80px",
      },
      {
        name: (
          <Tooltip title="Category Type" placement="top">
            <div>Type</div>
          </Tooltip>
        ),
        selector: (row) => row.categoryType || "--",
        sortable: true,
        minWidth: "100px",
        maxWidth: "100px",
      },
      {
        name: (
          <Tooltip title="Balance Point" placement="top">
            <div>BL Point</div>
          </Tooltip>
        ),
        selector: (row) => row.availablePoints || 0,
        sortable: true,
        minWidth: "90px",
        maxWidth: "90px",
      },
      {
        name: <div>Country Code</div>,
        selector: (row) => row.countryCode || "--",
        sortable: true,
        minWidth: "90px",
        maxWidth: "90px",
      },
      {
        id: "reward",
        name: <div>Reward</div>,
        selector: (row) => row.rewardId || 0,
        cell: (row) => (
          <Tooltip title={row.rewardName || "--"} placement="top">
            <div>
              {row.rewardId === 1 || row.rewardId == null ? (
                <img
                  src="https://panel.opinion-edge.com/assets/images/Tango_reward.jpg"
                  alt="tango"
                  style={{
                    width: "40px",
                    height: "40px",
                    objectFit: "contain",
                    borderRadius: "12px",
                  }}
                />
              ) : (
                <img
                  src="https://panel.opinion-edge.com/assets/images/paypal.webp"
                  alt="paypal"
                  style={{
                    width: "45px",
                    height: "45px",
                    objectFit: "contain",
                    borderRadius: "12px",
                  }}
                />
              )}
            </div>
          </Tooltip>
        ),
        sortable: true,
        minWidth: "100px",
        maxWidth: "100px",
      },
      {
        name: (
          <Tooltip title="Reconcile Rate" placement="top">
            <div>RRate</div>
          </Tooltip>
        ),
        selector: (row) => (row.RRate == null ? "0.00" : row.RRate),
        sortable: true,
        minWidth: "100px",
        maxWidth: "100px",
      },
      {
        name: "Source",
        selector: (row) => row?.sourceName || "--",
        cell: (row) =>
          row?.sourceName ? (
            <Tooltip title={row.sourceName} placement="top">
              <div>{row.sourceName}</div>
            </Tooltip>
          ) : (
            "--"
          ),
        sortable: true,
        minWidth: "140px",
        maxWidth: "140px",
      },
      {
        name: "Points",
        selector: (row) => row.point,
        sortable: true,
      },
      {
        name: "Amount",
        selector: (row) => row.amount,
        sortable: true,
        cell: (row) => `${row.amount} ${row.currencyCode}`,
      },
      {
        name: <div>USD Amount</div>,
        selector: (row) => row?.USDAmount,
        cell: (row) => (
          <Tooltip
            title={
              row?.lastSurvey
                ? `Last Survey Date: ${moment(row.lastSurvey).format("DD-MM-YYYY")}`
                : "Last Survey Date: --"
            }
            placement="top"
          >
            <div className="text-underline">{row.USDAmount}</div>
          </Tooltip>
        ),
        sortable: true,
        minWidth: "80px",
        maxWidth: "80px",
      },
      {
        name: (
          <Tooltip title="Conversion Rate" placement="top">
            <div className="conversion-header">CNV Rate</div>
          </Tooltip>
        ),
        selector: (row) => row.conversionRate,
        sortable: true,
        minWidth: "80px",
        maxWidth: "80px",
        omit: value === "pending",
      },
      {
        name: (
          <Tooltip title="VisitorId Count" placement="top">
            <div className="conversion-header">VID</div>
          </Tooltip>
        ),
        selector: (row) => row.visitorCount,
        cell: (row) => (
          <CustomTooltip
            title={row.visitorId || "Visitor ID Not Found"}
            childrenText={row.visitorCount || "--"}
            copiedText
          />
        ),
        sortable: true,
        minWidth: "80px",
        maxWidth: "80px",
      },
      {
        name: (
          <Tooltip title="Redemption Status" placement="top">
            <div>Status</div>
          </Tooltip>
        ),
        selector: (row) => row.redemptionStatus,
        cell: (row) => (
          <Tooltip title={row.redemptionStatus} placement="top">
            <div>{row.redemptionStatus}</div>
          </Tooltip>
        ),
        sortable: true,
        minWidth: "100px",
        maxWidth: "100px",
        omit:
          value !== "pending" && value !== "failed" && value !== "hold"
            ? true
            : false,
      },
      {
        name: firstLetterCaps(value) + " By",
        selector: (row) => row?.updatedBy,
        cell: (row) => (
          <CustomTooltip
            title={row.updatedBy || "Email ID Not Found"}
            childrenText={row.updatedBy || "--"}
            copiedText
          />
        ),
        sortable: true,
        minWidth: "150px",
        maxWidth: "150px",
        omit:
          value !== "approved" && value !== "disapproved" && value !== "hold"
            ? true
            : false,
      },
      {
        name: <div>Reason</div>,
        selector: (row) => row.disapprovedReason,
        cell: (row) =>
          row?.disapprovedReason == null ? (
            "--"
          ) : (
            <CustomTooltip
              title={row.disapprovedReason}
              childrenText={row.disapprovedReason}
            />
          ),
        sortable: true,
        minWidth: "100px",
        maxWidth: "100px",
        omit: value !== "hold",
      },
      {
        name: <div>Created On</div>,
        selector: (row) =>
          row?.createdAt ? moment(row.createdAt).format("YYYY-MM-DD") : "--",
        sortable: true,
        minWidth: "120px",
        maxWidth: "120px",
      },
      {
        name: <div>Updated On</div>,
        selector: (row) => moment(row?.updatedAt).format("YYYY-MM-DD"),
        sortable: true,
        minWidth: "120px",
        maxWidth: "120px",
        omit: value === "pending",
      },
      {
        name: (
          <Tooltip title="Redemption Action" placement="top">
            <div>Action</div>
          </Tooltip>
        ),
        selector: (row) => row.status,
        sortable: false,
        minWidth: "150px",
        cell: (row) => {
            if (value === "failed") {
              return (
                <Button
                  size="small"
                  variant="outlined"
                  startIcon={<Done fontSize="small" />}
                  disabled={actionsDisabled}
                  onClick={() => handleMenuActionRef.current("undoStatus", row)}
                  sx={{ textTransform: "capitalize" }}
                >
                  Verify
                </Button>
              );
            }

            if (ACTION_TABS.includes(value)) {
              return (
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Tooltip title="Approve">
                      <span>
                        <IconButton
                          size="small"
                          disabled={actionsDisabled}
                          onClick={() => handleMenuActionRef.current("approve", row)}
                        >
                          
                          <Done />
                        </IconButton>
                      </span>
                    </Tooltip>
      
                    <Tooltip title="Disapprove">
                      <span>
                        <IconButton
                          size="small"
                          disabled={actionsDisabled}
                          onClick={() => handleMenuActionRef.current("disapprove", row)}
                        >
                          <Close />
                        </IconButton>
                      </span>
                    </Tooltip>
      
                    <Tooltip title="More actions">
                      <span>
                        <IconButton
                          size="small"
                          disabled={actionsDisabled}
                          onClick={(e) => handleMenuOpen(e, row)}
                        >
                          <MoreVert fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                </Stack>
              )
            }
            return row.status;
          },
        omit: !ACTION_TABS.includes(value) && value !== "failed",
      },
    ],
    [value, isApprovedBtn, isPauseBtn, actionsDisabled, approveRequestHandler, handleApprove, firstLetterCaps, handleMenuOpen]
  );

  // ─── Conditional row styles (static — defined outside component ideally,
  //     but kept here to match original structure) ────────────────────────────

  const conditionalRowStyles = useMemo(
    () => [
      {
        when: (row) => row.redeemCount === 1,
        style: { backgroundColor: "rgb(255 0 0 / 14%)" },
      },
      {
        when: (row) => row.profit === null || parseFloat(row.profit) < 0,
        style: { color: "#ffffff", backgroundColor: "#c16f6ff0" },
      },
      {
        when: (row) => Number(row.RRate) >= 20,
        style: { color: "#ffffff", backgroundColor: "#8d4b76" },
      },
      {
        when: (row) =>
          Number(row.totalRedeemedUsd) >= Number(row.w9Limit) &&
          Number(row.w9Status) !== 1 &&
          row.countryCode === "US",
        style: { color: "#ffffff", backgroundColor: "#cd6007" },
      },
    ],
    []
  );

  // ─── Shared search field (avoids repeating JSX) ───────────────────────────────

  const SearchField = (
    <TextField
      type="search"
      value={searchQuery}
      fullWidth
      label="Search"
      name="Search"
      onChange={handleSearch}
    />
  );

  // ─── Render ───────────────────────────────────────────────────────────────────

  return (
    <>
      <div>
        <SnackBarAlert
          id="divSnackBar"
          open={alert}
          handleClose={handleCloseAlert}
        />
        <AnimatedPage>
          <TopHeading
            heading="Redemption Request"
            showButton={Boolean(false)}
            openModal={handleOpenModal}
          />

          <Paper sx={{ px: 3, py: 1, mx: 2, mb: 2 }} elevation={1}>
            <Stack
              direction={"row"}
              sx={{ mb: 2, my: 2 }}
              spacing={2}
              alignItems={"flex-start"}
            >
              <Grid container spacing={2}>
                <Grid item xs={2} sm={2} md={2}>
                  <TextField
                    fullWidth
                    InputProps={{ inputProps: { max: filterData.maxDate } }}
                    name={"startDate"}
                    value={filterData.startDate}
                    sx={{
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "2px solid #f0f0f0",
                      },
                    }}
                    label={"Start Date"}
                    type={"date"}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={2} sm={2} md={2}>
                  <TextField
                    fullWidth
                    InputProps={{ inputProps: { max: filterData.maxDate } }}
                    name={"endDate"}
                    value={filterData.endDate}
                    sx={{
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "2px solid #f0f0f0",
                      },
                    }}
                    label={"End Date"}
                    type={"date"}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={3} sm={3} md={3}>
                  <FormControl fullWidth sx={{ width: "100%" }}>
                    <InputLabel id="demo-multiple-checkbox-label">
                      Country
                    </InputLabel>
                    <Select
                      labelId="mutiple-select-label"
                      id="demo-multiple-checkbox"
                      multiple
                      value={selectedCountry}
                      onChange={handleChangeCountry}
                      renderValue={(selected) => selected.join(", ")}
                      MenuProps={MenuProps}
                      variant="outlined"
                      label="Country"
                    >
                      <MenuItem value="all">
                        <ListItemIcon>
                          <Checkbox checked={isAllSelected} />
                        </ListItemIcon>
                        <ListItemText primary="Select All" />
                      </MenuItem>
                      {sortedCountryList.map((option) => (
                        <MenuItem key={option.countryCode} value={option.countryCode}>
                          <ListItemIcon>
                            <Checkbox
                              checked={
                                selectedCountry.indexOf(option.countryCode) > -1
                              }
                            />
                          </ListItemIcon>
                          <ListItemText
                            primary={option.countryName + "-" + option.language}
                          />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={3} sm={3} md={3}>
                  <FormControl fullWidth sx={{ width: "100%" }}>
                    <InputLabel id="category-multiple-checkbox-label">
                      Select Category
                    </InputLabel>

                    <Select
                      labelId="category-multiple-checkbox-label"
                      id="category-multiple-checkbox"
                      multiple
                      value={selectedCategory}
                      onChange={handleCategoryChange}
                      renderValue={(selected) => selected.join(", ")}
                      label="Select Category"
                    >
                      <MenuItem value="all">
                        <ListItemIcon>
                          <Checkbox checked={isAllCategorySelected} />
                        </ListItemIcon>
                        <ListItemText primary="Select All" />
                      </MenuItem>
                      {sortedCategoryList.map((item) => (
                        <MenuItem key={item.categoryType} value={item.categoryType}>
                          <ListItemIcon>
                            <Checkbox
                              checked={selectedCategory.indexOf(item.categoryType) > -1}
                            />
                          </ListItemIcon>
                          <ListItemText primary={item.categoryType} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2} sm={2} md={2}>
                  <section className="d-flex gap-3 align-items-center">
                    <LoadingButton
                      disabled={
                        moment(filterData.endDate).diff(
                          moment(filterData.startDate),
                          "days"
                        ) < 0
                      }
                      onClick={handleSearchFilter}
                      variant="contained"
                      sx={{ px: 4, textTransform: "capitalize", my: 1 }}
                    >
                      Search
                    </LoadingButton>
                    <div className="tb-box-group">
                      <Tooltip title="W9 form pending verification" placement="left">
                        <span className="tb-box w9Redeem"></span>
                      </Tooltip>
                      <Tooltip title="High reconcile rate" placement="left">
                        <span className="tb-box RRcheck"></span>
                      </Tooltip>
                      
                      <Tooltip title="Profit is negative." placement="left">
                        <span className="tb-box negativeRedeem"></span>
                      </Tooltip>
                      
                      <Tooltip title="First redemption." placement="left">
                        <span className="tb-box firstTimeRedeem"></span>
                      </Tooltip>
                    </div>
                  </section>
                </Grid>
              </Grid>
            </Stack>
          </Paper>

          {selectedPanel?.panelGuid ? (
            <>
              <ConfRedemption
              open={openEditModal}
              loading={loading}
              hadnleCloseModal={handleCloseEditModal}
              setSuccess={setSuccess}
              setError={setError}
              setAlert={setAlert}
              dataUpdated={dataUpdated}
              setDataUpdated={setDataUpdated}
              setRedemptionResponseData={setRedemptionResponseData}
              selectedItem={selectedItem}
              actionStatus={actionStatus}
              confirmMessage={confirmMessage}
              panelGuid={selectedPanel?.panelGuid}
            />
            <Menu
              anchorEl={menuAnchor}
              open={Boolean(menuAnchor)}
              onClose={handleMenuClose}
            >
              {getActionsForTab(value).map((key) => (
                <MenuItem key={key} onClick={() => handleMenuAction(key)}>
                  <ListItemIcon>{ACTION_META[key].icon}</ListItemIcon>
                  <ListItemText primary={ACTION_META[key].label} />
                </MenuItem>
              ))}
            </Menu>

            <Dialog open={Boolean(approveRow)} onClose={() => setApproveRow(null)}>
              <DialogContent sx={{
                fontSize:"1.25rem",
                fontWeight:"500",
                fontFamily:"Roboto, Helvetica, Arial, sans-serif"
              }}>Are you sure you want to approved Redemption?</DialogContent>
              <DialogActions>
               
                <Button variant="outlined" sx={{ textTransform: "capitalize" }} onClick={() => setApproveRow(null)}>No</Button>
                <Button
                  variant="contained"
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => {
                    approveRequestHandler(approveRow.id, approveRow.utid, approveRow.panelId);
                    setApproveRow(null);
                  }}
                >
                  Yes, Approve
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog open={Boolean(statusConfirm)} onClose={() => setStatusConfirm(null)}>
                <DialogContent
                  sx={{
                    fontSize: "1.25rem",
                    fontWeight: "500",
                    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                  }}
                >
                  Are you sure you want to {statusConfirm?.title}?
                </DialogContent>
                <DialogActions>
                  <Button
                    variant="outlined"
                    sx={{ textTransform: "capitalize" }}
                    onClick={() => setStatusConfirm(null)}
                  >
                    No
                  </Button>
                  <Button
                    variant="contained"
                    sx={{ textTransform: "capitalize" }}
                    onClick={() => {
                      changeStatusHandler(
                        statusConfirm.row,
                        statusConfirm.newStatus,
                        statusConfirm.successMsg
                      );
                      setStatusConfirm(null);
                    }}
                  >
                    Yes, Confirm
                  </Button>
                </DialogActions>
              </Dialog>
            </>
          ) : (
            ""
          )}
          <TabContext value={value} className="align-items-center">
            <Box sx={{ mx: 4, my: 2 }}>
              <Tabs
                onChange={handleChange}
                value={activeMoreTab ? "more" : value}
                aria-label="Redemption status tabs"
                selectionFollowsFocus
                className="d-flex justify-content-between align-items-center"
              >
                    {
                    MAIN_TABS.map((t) => (
                        <Tab key={t.value} label={t.label} value={t.value} />
                      ))
                    }

                    <Tab
                      value="more"
                      label={activeMoreTab ? activeMoreTab.label : "More"}
                      icon={<KeyboardArrowDown />}
                      iconPosition="end"
                      onClick={(e) => setMoreAnchor(e.currentTarget)}
                    />
                                      <Menu
                    anchorEl={moreAnchor}
                    open={Boolean(moreAnchor)}
                    onClose={() => setMoreAnchor(null)}
                  >
                    {MORE_TABS.map((t) => (
                      <MenuItem
                        key={t.value}
                        selected={t.value === value}
                        onClick={() => {
                          handleChange(null, t.value);
                          setMoreAnchor(null);
                        }}
                      >
                        {t.label}
                      </MenuItem>
                    ))}
                  </Menu>
                <button
                  onClick={downloadRedemptionData}
                  className="download-button"
                  type="button"
                  style={{ marginLeft: "auto"}}
                >
                  <span className="download-button__text">Download</span>
                  <span className="download-button__icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 35 35"
                      id="bdd05811-e15d-428c-bb53-8661459f9307"
                      data-name="Layer 2"
                      className="svg"
                    >
                      <path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path>
                      <path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path>
                      <path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path>
                    </svg>
                  </span>
                </button>
              </Tabs>


              <TabPanel value={"pending"} index={"pending"}>
                <Stack spacing={2}>
                  {SearchField}
                  <div
                    className={actionsDisabled ? "divFilter" : "divFilter1"}
                    id="parentRedemptio"
                  >
                    <CustomDataTable
                      columns={columns}
                      data={filteredData}
                      pagination={true}
                      progressPending={pending}
                      highlightOnHover
                      conditionalRowStyles={conditionalRowStyles}
                    />
                  </div>
                </Stack>
              </TabPanel>
              <TabPanel value={"approved"} index={"approved"}>
                <Stack spacing={2}>
                  {SearchField}
                  <div>
                    <CustomDataTable
                      columns={columns}
                      data={filteredData}
                      pagination={true}
                      progressPending={pending}
                      highlightOnHover
                    />
                  </div>
                </Stack>
              </TabPanel>
              <TabPanel value={"disapproved"} index={"disapproved"}>
                <Stack spacing={2}>
                  {SearchField}
                  <div>
                    <CustomDataTable
                      columns={columns}
                      data={filteredData}
                      pagination={true}
                      progressPending={pending}
                      highlightOnHover
                    />
                  </div>
                </Stack>
              </TabPanel>

              <TabPanel value={"failed"} index={"failed"}>
                <Stack spacing={2}>
                  {SearchField}
                  <div>
                    <CustomDataTable
                      columns={columns}
                      data={filteredData}
                      pagination={true}
                      progressPending={pending}
                      highlightOnHover
                    />
                  </div>
                </Stack>
              </TabPanel>

              <TabPanel value={"hold"} index={"hold"}>
                <Stack spacing={2}>
                  {SearchField}
                  <div
                    className={actionsDisabled ? "divFilter" : "divFilter1"}
                    id="parentHoldRedemptio"
                  >
                    <CustomDataTable
                      columns={columns}
                      data={filteredData}
                      pagination={true}
                      progressPending={pending}
                      highlightOnHover
                      conditionalRowStyles={conditionalRowStyles}
                    />
                  </div>
                </Stack>
              </TabPanel>

              <TabPanel value={"underReview"} index={"underReview"}>
                <Stack spacing={2}>
                  {SearchField}
                  <div>
                    <CustomDataTable
                      columns={columns}
                      data={filteredData}
                      pagination={true}
                      progressPending={pending}
                      highlightOnHover
                    />
                  </div>
                </Stack>
              </TabPanel>

              <TabPanel value={"awaitingApproval"} index={"awaitingApproval"}>
                <Stack spacing={2}>
                  {SearchField}
                  <div>
                    <CustomDataTable
                      columns={columns}
                      data={filteredData}
                      pagination={true}
                      progressPending={pending}
                      highlightOnHover
                    />
                  </div>
                </Stack>
              </TabPanel>

              <TabPanel value={"verification"} index={"verification"}>
                <Stack spacing={2}>
                  {SearchField}
                  <div>
                    <CustomDataTable
                      columns={columns}
                      data={filteredData}
                      pagination={true}
                      progressPending={pending}
                      highlightOnHover
                    />
                  </div>
                </Stack>
              </TabPanel>
            </Box>
          </TabContext>
        </AnimatedPage>

        
      </div>
    </>
  );
};

export const EnhancedRedemption = Hoc(Redemption, { name: "" });
